import { SEEN, COUNT } from '../actions/notificationActions';

const initialState = {
  count: 0,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEEN:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT:
      return {
        ...state,
        count: action.payload
      }
    default:
      return state;
  }
};
